///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../collections/report-manufacturers.collection.ts"/>
///<reference path="../collections/report-dp005-products.collection.ts"/>
///<reference path="../collection-population-strategies/product-cat-to-manufacturers.strategy.ts"/>
///<reference path="../collection-population-strategies/products-to-categories.strategy.ts"/>
///<reference path="../collections/report-dp005-product-variants.collection.ts"/>
///<reference path="../filter-templates/active-inactive-criteria.filter.ts"/>
///<reference path="../validation/required.validation.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import DP005ProductCategory = Meevo.Plugins.Reports.DP005ProductCategory;

    export class ReportDP005ProductsCategories extends DataTemplateBase implements IDataTemplate {

        protected productCategories: SmartMoverCollectionBase<DP005ProductCategory>;
        protected products: ReportDp005ProductsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.productCategories;
        }

        get leafCollection() {
            return this.products;
        }

        get totalSelectedCount() {
            return this.products.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.title = 'LABEL_PRODUCTS';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCTS';
            this.totalSelectedMessage = 'LABEL_PRODUCTS_SELECTED';

            angular.extend(options.criteria, {
                ProductState_TBL: [ObjectStateEnum.Active],
            });

            this.productCategories = new SmartMoverCollectionBase<DP005ProductCategory>(this.model[properties[0]], [], {
                idKey: 'cat_TId',
                CategoryModel: VirtualRepeatCategory
            });

            this.products = new ReportDp005ProductsCollection(this.model[properties[1]], [], {
                criteria: options.criteria,
                idKey: 'variant_TId',
                reportModel: model
            }, options.$scope);

            this.validation.push(new RequiredValidation(this.products, 'LABEL_PRODUCTS_REQUIRED'));

            this.products.setParentCollection(this.productCategories, ProductsToCategoriesStrategy);
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: angular.IQService) {
            this.products.updateCriteria(newCriteria);

            return this.fetch(this.dataService);
        }

        fetch(dataService: Meevo.Components.BaseClasses.IDataService) {
            return this.products
                .fetch(dataService)
                .then((data) => {
                    if (data.length === 0) return;

                    this.products.handleResponse(data);

                    const productCategories = data.reduce((categories, product) => {
                        const productCategory = product.dP005ProductCategories && product.dP005ProductCategories[0];
                        if (productCategory && !categories.some((category) => productCategory.cat_TId === category.cat_TId)) {
                            categories.push(productCategory)
                        }

                        return categories;
                    }, [] as DP005ProductCategory[]);


                    this.productCategories.handleResponse(
                        _.sortBy(productCategories, (cat) => cat.displayName)
                    );
                    this.products.filterList();
                    this.products.onModelValueChanged();

                    this.emit(ON_FETCH_END);
                });
        }

        setWatchers(scope: angular.IScope) {
            scope.$watch(() => this.smartMoverHidden, (newValue: boolean, oldValue: boolean) => {
                if (newValue === oldValue) return;

                this.products.onModelValueChanged();
            });
        }
    }
}
